import {SET_SESSION, CLEAR_SESSION} from "../actionTypes";

const initialState = {
  isLoggedIn: false
}

const userSession = (state = initialState, action) => {
  switch (action.type) {
    case SET_SESSION:
      return Object.assign({},
        action.session,
        { isLoggedIn: true })

    case CLEAR_SESSION:
      return initialState

    default:
      return state
  }
}

export default userSession
